import { AxiosError } from 'axios';

import { createAsyncThunk } from '@reduxjs/toolkit';

import { surfaceTypesApi } from '@/api/index';

export const fetchSurfaceTypes = createAsyncThunk(
  'surfaceTypes',
  async (params, thunkAPI) => {
    try {
      const response = await surfaceTypesApi.getAll();
      return response ? response.data.sort() : [];
    } catch (e) {
      if (e instanceof AxiosError) {
        return thunkAPI.rejectWithValue(e.message);
      }
      throw e;
    }
  },
);
